module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We would first like to offer our gratitude to Dr. Eric Hazel for his editorial assistance in reading our manuscript and offering many comments and suggestions for improving it. Because of his help, we believe it is a much better product.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thanks must also be given to the many fine people at The History Press who helped us through each of the stages of bringing the book to completion: Laura All, commissioning editor, who worked with us from the beginning, answering—cheerfully we might add—all of our questions; Marshall Hudson, senior designer, who provided the illustrations; and Jaime Muehl, project editor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We would also like to thank the helpful and friendly staffs of the North Carolina Room at the Central Branch of the Forsyth County Public Library in Winston-Salem, the Central Library in Greensboro and the North Carolina Collection of the city of High Point’s Public Library. They were always ready to answer our questions or to point out special features of their archival holdings. Thank you very much.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc40c2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 75
// module chunks = 0